module.exports = __webpack_public_path__ + "static/img/3hegongye.820b0b72.jpg";